// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3vCUk","buttons":"RemoveExpirationActionButtons_buttons__QEGKL"};